<template>
  <a
    :href="`${domain}/article/${data.id}?${utmSource}`"
    target="_blank"
    class="company-article-card t100-gradient-bg"
  >
    <div class="cover">
      <img :src="data.cover_img" alt="" />
    </div>
    <div class="title text-ellipsis-2">{{ data.title }}</div>
    <div class="card-foot">
      <div class="foot-left">人氣：{{ data.views }}</div>
      <div class="foot-right text-ellipsis">
        {{ data.publish_time }}
      </div>
    </div>
  </a>
</template>
<script>
import { primary_site_domain } from "@/config";
import { utmSource } from "@/utils/gen-utm-source";
export default {
  data() {
    return {
      utmSource,
      domain: primary_site_domain,
    };
  },
  props: ["data"],
};
</script>
<style lang="less">
.company-article-card {
  overflow: hidden;
  padding: 12px;
  display: block;
  @media (max-width: 768px) {
    padding: 6px;
  }
  .cover {
    height: 200px;
    border-radius: 12px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    @media (max-width: 768px) {
      height: 120px;
    }
  }
  .title {
    color: #333;
    font-weight: bold;
    margin-top: 10px;
    min-height: 54px;
    font-size: 18px;
    @media (max-width: 768px) {
      font-size: 14px;
      min-height: 45px;
    }
  }
  .card-foot {
    display: flex;
    margin-top: 6px;
    @media (max-width: 768px) {
      font-size: 11px;
      display: block;
    }
    .foot-left {
      flex: 1.5;
      display: flex;
    }
    .foot-right {
      flex: 1;
      text-align: right;
      min-height: 18px;
      @media (max-width: 768px) {
        text-align: left;
      }
    }
    .view {
      margin-left: 10px;
    }
  }
}
</style>